import { MatButtonModule } from '@angular/material/button'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { Client, VenueFilter } from '@monorepo-channels/channels/domain'
import { OptimizeImage } from '@monorepo-channels/shared/util-helpers'
import { BenefitsUiComponent } from '../benefits/benefits.component'

@Component({
	selector: 'ui-porto-bank-venue-card',
	standalone: true,
	imports: [CommonModule, MatIconModule, OptimizeImage, MatButtonModule, BenefitsUiComponent],
	templateUrl: './venue-card.component.html',
	styleUrls: ['./venue-card.component.scss'],
})
export class VenueCardUiComponent {
	@Input({ required: true }) venue!: VenueFilter
	@Output() clickCard = new EventEmitter<void>()
	@Output() addressRedirect = new EventEmitter<void>()
	@Input() client: Client | null = null
}
